export class OrderDeliveryRequestModel {
    deliveryStatus: string;
    orderId: string;
    scheduledDate: string;
    scheduledTime: string;
    address: string;
    userId: string;
    comment: string;
    receivedBy: string;
    proofOfDelivery: string;
    receivedAt: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/order/OrderDeliveryRequestModel.ts